import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_1: FaireProductEntity = {
  token: "sweet-wink-1",
  type: "product",
  name: "Patriotic Cutie Tutu - Girls - Kids Clothes - 4th of July",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/5e723450294e9288a835f4457d539a0cd62430d121bd23b7e3ea335cd58218b3.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1199,1199,x0,y0,safe&width=720",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
